export const MOMENT_FORMATTED_DATE = 'MM/DD/YYYY';
export const MOMENT_MO_DAY_YEAR_DATE_STR = 'MMM DD YYYY';
export const MOMENT_FULL_DATETIME_STR = `Do MMM h:mmA z, YYYY`;
export const DATE_MAX = new Date(8640000000000000);
